<template>
    <div >
        <div class="comment" v-if="display">
            <div class="_info py-2">
                Ingresa un comentario y hazle saber a los demás que te pareció este curso
            </div>
            <div class="_newcomment">
                <b-form-textarea
                    v-model="form.comment"
                    placeholder="Escribe un comentario..."
                    rows="1"
                    max-rows="1"></b-form-textarea>
                <div class="stars py-2 mb-2">
                    <ul class="list-inline font-yellow">
                        <li class="list-inline-item font-weight-bold">Tu valoración</li>
                        <li class="list-inline-item m-0" v-if="form.stars >= 1" data-star="1" @click="star(1)"><i class="fas fa-star"></i></li>
                        <li class="list-inline-item m-0" v-if="form.stars >= 2" data-star="2" @click="star(2)"><i class="fas fa-star"></i></li>
                        <li class="list-inline-item m-0" v-if="form.stars >= 3" data-star="3" @click="star(3)"><i class="fas fa-star"></i></li>
                        <li class="list-inline-item m-0" v-if="form.stars >= 4" data-star="4" @click="star(4)"><i class="fas fa-star"></i></li>
                        <li class="list-inline-item m-0" v-if="form.stars >= 5" data-star="5" @click="star(5)"><i class="fas fa-star"></i></li>

                        <li class="list-inline-item m-0" v-if="form.stars < 1" data-star="1" @click="star(1)"><i class="far fa-star"></i></li>
                        <li class="list-inline-item m-0" v-if="form.stars < 2" data-star="2" @click="star(2)"><i class="far fa-star"></i></li>
                        <li class="list-inline-item m-0" v-if="form.stars < 3" data-star="3" @click="star(3)"><i class="far fa-star"></i></li>
                        <li class="list-inline-item m-0" v-if="form.stars < 4" data-star="4" @click="star(4)"><i class="far fa-star"></i></li>
                        <li class="list-inline-item m-0" v-if="form.stars < 5" data-star="5" @click="star(5)"><i class="far fa-star"></i></li>

                    </ul>
                </div>
                <b-button type="button" class="b-orange" :disabled="loading.comment" @click="actionComment">
                <b-spinner v-if="loading.comment" small label="Espere ..."></b-spinner>
                    Publicar comentario
                </b-button>
            </div>
        </div>
        <div class="_commen" v-else>
            <div class="_commentuser b-green p-2 rounded shadow-sm">
                <i class="fas fa-smile"></i> Hemos enviado tu comentario
            </div>
        </div>
    </div>
</template>
<style scoped>
    .stars ul li:hover{
        cursor: pointer;
    }
</style>
<script>
export default {
    props:{
        curse_id: Number
    },
    data() {
        return {
            display: true,
            loading:{
                comment: false
            },
            form:{
                comment: '',
                stars: 0
            }
        }
    },
    methods: {
        star(s){
            this.form.stars = s
        },
        actionComment(){
            this.loading.comment = true
            this.api.post('student/curse/comment/' + this.curse_id, JSON.stringify(this.form)).then(({data}) => {
                this.loading.comment = false
                this.display = !data.comment
            }).catch(err => {
                this.loading.comment = false
            })
        }
    },

}
</script>


// WEBPACK FOOTER //
// src/components/#public/curse/components/content/CreateComment.vue